import { render, staticRenderFns } from "./DishDetailsOptionsSelect.vue?vue&type=template&id=28915722&scoped=true&"
import script from "./DishDetailsOptionsSelect.vue?vue&type=script&lang=js&"
export * from "./DishDetailsOptionsSelect.vue?vue&type=script&lang=js&"
import style0 from "./DishDetailsOptionsSelect.vue?vue&type=style&index=0&id=28915722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28915722",
  null
  
)

export default component.exports